import _en from './en';
import _ja from './ja';
let enData = {};
Object.keys(_en).forEach(k => {
  enData[k] = _en[k] || k;
});
export const EN = enData;
export const JP = _ja;
